var ltr6_module_radar_icon = (function (ltr6_module_radar_icon) {

    ltr6_module_radar_icon.init = function(){
      var icon = $('#ltr6-wrapper .ltr6-navigation .ltr6-nav-radar svg');
      var innerRing = $('.ltr6-radar-icon-inner-ring path', icon)[0];
      var outerRing = $('.ltr6-radar-icon-outer-ring path', icon)[0];
      var bar = $('.ltr6-radar-icon-bar', icon);
      var rings = $('.ltr6-radar-icon-outer-rings', icon);

      var il = innerRing.getTotalLength();
      var ol = outerRing.getTotalLength();
      TweenLite.set(innerRing, {strokeDasharray:il});
      TweenLite.set(outerRing, {strokeDasharray:ol});

      var d = 0.27;
      var t = 2;
      var tt = 8;
      // var ease = Linear.easeNone;
      var ease = Power2.easeInOut;
      
      // var ringsTimeline = new TimelineMax({paused:true});
      // ringsTimeline.set(rings, {opacity:1});
      // ringsTimeline.to(rings, t/8, {opacity:0,ease:ease}, 0);

      var innerRingTimeline = new TimelineMax({paused:true});
      innerRingTimeline.set(innerRing, {strokeDashoffset:il});
      // innerRingTimeline.set(innerRing, {opacity:0});
      innerRingTimeline.to(innerRing, t, {strokeDashoffset:0,ease:ease}, 0);
      innerRingTimeline.to(innerRing, 7*(t/8), {opacity:1,ease:ease}, t/8);
      innerRingTimeline.to(innerRing, 2, {strokeDashoffset:-il,opacity:1,ease:ease}, tt-2);

      var outerRingTimeline = new TimelineMax({paused:true});
      outerRingTimeline.set(outerRing, {strokeDashoffset:ol});
      // outerRingTimeline.set(outerRing, {opacity:0});
      outerRingTimeline.to(outerRing, t, {strokeDashoffset:0,ease:ease}, 0);
      outerRingTimeline.to(outerRing, 7*(t/8), {opacity:1,ease:ease}, t/8);
      innerRingTimeline.to(outerRing, 2, {strokeDashoffset:-ol,opacity:1,ease:ease}, tt-2);

      var barTimeline = new TimelineMax({paused:true});
      barTimeline.set(bar, {transformOrigin:"8px 8px",rotation:0});
      barTimeline.to(bar, t, {transformOrigin:"8px 8px",rotation:360,ease:ease}, 0);

      // ringsTimeline.play();
      innerRingTimeline.play();
      outerRingTimeline.play();
      barTimeline.play();

      setInterval(function(){
        // ringsTimeline.seek(0).play();
        innerRingTimeline.seek(0).play();
        outerRingTimeline.seek(0).play();
        barTimeline.seek(0).play();
      }, tt*1000);

      // TweenLite.fromTo(bar,t,{transformOrigin:"8px 8px",rotation:0},{transformOrigin:"8px 8px",rotation:360,repeat:-1,ease:Linear.easeNone});
      // TweenLite.fromTo(innerRing,1,{strokeDashoffset:il},{strokeDashoffset:0,repeat:-1,ease:Linear.easeNone});
      // TweenLite.fromTo(outerRing,1,{strokeDashoffset:ol},{strokeDashoffset:0,repeat:-1,ease:Linear.easeNone});
    };

    return ltr6_module_radar_icon;
}(ltr6_module_radar_icon || {}));